<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">農産フロント連携</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="column-list">
          <label class="list-input-title">対象</label>
          <div class="list-input-content element-column">
            <app-radio-label [label]="'商品企画情報'" id="btn_UploadPlanGoods" #btn_UploadPlanGoods 
              [subid]="'btn_UploadPlanGoods'" [forcedEnabledMode]="''" [tabindex]="0" value="1" groupname="upload_List"
              [(ngModel)]="KYMW2900Model.uploadType">
            </app-radio-label>
            <app-radio-label label="産地コメント情報" id="btn_UploadComment" #btn_UploadComment
              [subid]="'btn_UploadComment'" [forcedEnabledMode]="''" [tabindex]="0" value="2" groupname="upload_List"
              [(ngModel)]="KYMW2900Model.uploadType">
            </app-radio-label>
          </div>

        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" forcedEnabledMode="" id="btn_Upload" #btn_Upload
            [tabindex]="0" (click)="eventUpload_CLICKHandler()">取込
          </button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button  forcedEnabledMode="true" id="btn_Close" #btn_Close 
            [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>